<script setup>
import { defineProps } from 'vue';

// Пропсы для иконки
const props = defineProps({
  name: {
    type: String,
    required: true,
  },
  color: {
    type: String,
    default: 'white',
  },
  width: {
    type: [String, Number],
    default: '20',
  },
  height: {
    type: [String, Number],
    default: '20',
  },
});

</script>

<template>
  <svg class="svg_icon_common" :width="props.width" :height="props.height" viewBox="0 0 24 24" :fill="'transparent'"
    :color="props.color" xmlns="http://www.w3.org/2000/svg" v-if="props.name === 'share'">
    <path
      d="M17 7.61719C18.6569 7.61719 20 6.27404 20 4.61719C20 2.96033 18.6569 1.61719 17 1.61719C15.3431 1.61719 14 2.96033 14 4.61719C14 6.27404 15.3431 7.61719 17 7.61719Z"
      stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M5 14.6172C6.65685 14.6172 8 13.274 8 11.6172C8 9.96033 6.65685 8.61719 5 8.61719C3.34315 8.61719 2 9.96033 2 11.6172C2 13.274 3.34315 14.6172 5 14.6172Z"
      stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M17 21.6172C18.6569 21.6172 20 20.274 20 18.6172C20 16.9603 18.6569 15.6172 17 15.6172C15.3431 15.6172 14 16.9603 14 18.6172C14 20.274 15.3431 21.6172 17 21.6172Z"
      stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M7.59375 13.125L14.4237 17.105" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
      stroke-linejoin="round" />
    <path d="M14.4137 6.125L7.59375 10.105" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
      stroke-linejoin="round" />
  </svg>

  <svg class="svg_icon_common" :width="props.width" :height="props.height" viewBox="0 0 24 24"  :fill="'transparent'"
    :color="props.color" xmlns="http://www.w3.org/2000/svg" v-if="props.name === 'cloud'">
    <path
      d="M8.38702 18.0006H5.2948C2.96599 18.0006 1.07812 16.1127 1.07812 13.7839V13.7839C1.07812 11.4551 2.96599 9.56727 5.2948 9.56727H5.57591V9.38281C5.57591 6.0691 8.2622 3.38281 11.5759 3.38281H11.9448C15.2585 3.38281 17.9448 6.0691 17.9448 9.38281V10.6917H19.3504C21.3687 10.6917 23.0048 12.3279 23.0048 14.3462V14.3462C23.0048 16.3645 21.3687 18.0006 19.3504 18.0006H11.7604V10.1295"
      stroke="currentColor" stroke-width="1.5" />
    <path d="M14.5276 12.5198L11.7969 9.78906L9.06618 12.5198" stroke="currentColor" stroke-width="1.12445"
      stroke-linecap="round" />
  </svg>

  <svg class="svg_icon_common" :width="props.width" :height="props.height" viewBox="0 0 24 24"  :color="props.color"
    xmlns="http://www.w3.org/2000/svg" v-if="props.name === 'lock'">
    <path
      d="M18.2222 9H5.77778C4.79594 9 4 10.0582 4 11.3636V19.6364C4 20.9418 4.79594 22 5.77778 22H18.2222C19.2041 22 20 20.9418 20 19.6364V11.3636C20 10.0582 19.2041 9 18.2222 9Z"
      stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="transparent" />
    <path
      d="M7 9V7C7 5.67392 7.52678 4.40215 8.46447 3.46447C9.40215 2.52678 10.6739 2 12 2C13.3261 2 14.5979 2.52678 15.5355 3.46447C16.4732 4.40215 17 5.67392 17 7V9"
      stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" fill="transparent"/>
    <circle cx="12" cy="15" r="2" fill="currentColor" />
  </svg>

  <svg class="svg_icon_common" :width="props.width" :height="props.height" viewBox="0 0 24 24"  :fill="'transparent'"
    :color="props.color" xmlns="http://www.w3.org/2000/svg" v-if="props.name === 'trash'">
    <path d="M3 6H5H21" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M9 3H9.66667H15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path
      d="M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6"
      stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M10 11V17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    <path d="M14 11V17" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
  </svg>




</template>

<style lang="scss">
.svg_icon_common{
  transform:translateY(-1px);
}

</style>
